export default __webpack_public_path__ + "static/gameface-logo-fa47f4ea8dfabb4c78b8d42b5683ee0b.png";